/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

// thanks GrabGPT
import { isEqual } from "lodash"

/**
 * create a propsAreEqual function to be used in React.memo,
 * which accepts a list of keys that is going to be deep-compared using lodash.
 * @param keysToDeepCompareArg keys of the props
 * @returns a propsAreEqual function
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createPropsAreEqual<T extends Record<string, unknown>>(
  keysToDeepCompareArg: Array<keyof T>,
) {
  const keysToDeepCompare = new Set(keysToDeepCompareArg)
  return (prevProps: T, nextProps: T): boolean => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(prevProps)) {
      if (keysToDeepCompare.has(key as keyof T)) {
        // Deep comparison using lodash's isEqual
        if (!isEqual(prevProps[key as keyof T], nextProps[key as keyof T])) {
          return false
        }
      } else if (
        !Object.is(prevProps[key as keyof T], nextProps[key as keyof T])
      ) {
        // Shallow comparison for the rest of the props
        return false
      }
    }

    return true
  }
}

export default createPropsAreEqual
